import { render } from "./BaseCard.vue?vue&type=template&id=37f558a5&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=37f558a5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f558a5"]])

export default __exports__